<template>
    <transition name="confirm-fade">
        <div class="modal-mask confirm-main" v-if="visible">
            <div class="mask-backdrop"></div>
            <div class="confirm-content">
                <p class="confirm-title">
                    <!-- <img :src="iconSrc"> -->
                    {{ title }}
                </p>
                <p class="small-title">{{ smallTitle }}</p>
                <div class="confirm-btn-group">
                    <button v-if="okBtn" class="confirm-btn-ok" @click="okEvent">{{ okBtnTitle }}</button>
                    <button v-if="cancelBtn" class="confirm-btn-cancle" @click="cancelEvent">{{ cancelBtnTitle }}</button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    data: function () {
        return {
            visible: false,

            title: '',

            smallTitle: '',

            okBtn: true,

            cancelBtn: true,

            okBtnTitle: '确定',

            cancelBtnTitle: '取消',

            okBtnCallback: null,

            cancelBtnCallback: null,

            type: 'error',

            closed: false
        }
    },
    props: {

    },

    watch: {
        closed: function (newVal) {
            if (newVal) {
                this.visible = false
                this.$el.addEventListener('transitionend', this.destroyElement)
            }
        }
    },

    computed: {
        iconSrc: function () {
            /* eslint-disable template-curly-spacing */
            return require(`@img/tip-${ this.type }.png`)
        }
    },

    methods: {
        okEvent () {
            if (typeof this.okBtnCallback === 'function') {
                this.okBtnCallback(this.close)
            } else {
                this.close()
            }
        },
        cancelEvent () {
            if (typeof this.cancelBtnCallback === 'function') {
                this.cancelBtnCallback(this.close)
            } else {
                this.close()
            }
        },
        close: function () {
            this.closed = true
            if (typeof this.onClose === 'function') {
                this.onClose(this)
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    @import '../../scss/common/confirm.scss';
</style>



// WEBPACK FOOTER //
// src/components/lib/confirm.vue